export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 bg-background-50 rounded-2xl p-8 md:p-10 border border-background-200/70">
          <div className="flex-shrink-0">
            <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500/10 flex items-center justify-center">
              <i className="ri-smartphone-line text-3xl md:text-4xl text-primary-500"></i>
            </div>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">随时随地，手机追剧</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              色影视全面适配移动端浏览器，无需下载APP即可享受高清不缓冲追剧体验。支持画中画模式、手势调节亮度和音量、投屏到电视大屏等功能，通勤路上、午休时间、睡前放松，打开浏览器就能无缝追剧。
            </p>
            <div className="flex items-center gap-4 mt-4 justify-center md:justify-start">
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-apple-line"></i> iOS Safari
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-android-line"></i> Android Chrome
              </span>
              <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                <i className="ri-computer-line"></i> PC 浏览器
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}